/** @jsx jsx */
import React from "react"; // eslint-disable-line no-unused-vars
import { jsx } from "theme-ui";
import AiOutlineSlack from "./icons/ai/AiOutlineSlack.js";
import AiOutlineHeart from "./icons/ai/AiOutlineHeart.js";
import AiOutlineGithub from "./icons/ai/AiOutlineGithub.js";
import AiOutlineTwitter from "./icons/ai/AiOutlineTwitter.js";
import BiPaperPlane from "./icons/bi/BiErrorCircle.js";
import BiErrorCircle from "./icons/bi/BiErrorCircle.js";
import BiCheckCircle from "./icons/bi/BiCheckCircle.js";
import BsArrowRightShort from "./icons/bs/BsArrowRightShort.js";
import BsTwitterX from "./icons/bs/BsTwitterX.js";
import IoIosCloudCircle from "./icons/io/IoIosCloudCircle.js";
import IoIosInformationCircle from "./icons/io/IoIosInformationCircle.js";
import IoClose from "./icons/io/IoClose.js";
import FiChevronDown from "./icons/fi/FiChevronDown.js";
import FiChevronLeft from "./icons/fi/FiChevronLeft.js";
import FiChevronRight from "./icons/fi/FiChevronRight.js";
import FiChevronUp from "./icons/fi/FiChevronUp.js";
import FiArrowDown from "./icons/fi/FiArrowDown.js";
import FiArrowLeft from "./icons/fi/FiArrowLeft.js";
import FiArrowRight from "./icons/fi/FiArrowRight.js";
import FiExternalLink from "./icons/fi/FiExternalLink.js";
import FiMail from "./icons/fi/FiMail.js";
import FiSearch from "./icons/fi/FiSearch.js";
import FiVolume2 from "./icons/fi/FiVolume2.js";
import RiDoubleQuotesL from "./icons/ri/RiDoubleQuotesL.js";
import FaLinkedinIn from "./icons/fa/FaLinkedinIn.js";
import FaCheck from "./icons/fa/FaCheck.js";
import FaSearch from "./icons/fa/FaSearch.js";
import MdKeyboardArrowDown from "./icons/md/MdKeyboardArrowDown.js";
import MdKeyboardArrowUp from "./icons/md/MdKeyboardArrowUp.js";
import MdOutlineKeyboardArrowRight from "./icons/md/MdOutlineKeyboardArrowRight.js";
import MdOutlineKeyboardArrowLeft from "./icons/md/MdOutlineKeyboardArrowLeft.js";
import Discourse from "./icons/DiscourseIcon.js";

const Icon = ({ icon, ...props }) => {
  switch (icon) {
    case "slack":
      return <AiOutlineSlack {...props} />;
    case "heart":
      return <AiOutlineHeart {...props} />;
    case "github":
      return <AiOutlineGithub {...props} />;
    case "paper plane":
      return <BiPaperPlane {...props} />;
    case "bs-arrow-right":
      return <BsArrowRightShort {...props} />;
    case "cloud":
      return <IoIosCloudCircle {...props} />;
    case "info":
      return <IoIosInformationCircle {...props} />;
    case "io-close":
      return <IoClose {...props} />;
    case "down-chevron":
      return <FiChevronDown {...props} />;
    case "left-chevron":
      return <FiChevronLeft {...props} />;
    case "right-chevron":
      return <FiChevronRight {...props} />;
    case "left-arrow":
      return <FiArrowLeft {...props} />;
    case "right-arrow":
      return <FiArrowRight {...props} />;
    case "down-arrow":
      return <FiArrowDown {...props} />;
    case "megaphone":
      return <FiVolume2 {...props} />;
    case "ri-double-quotes-l":
      return <RiDoubleQuotesL {...props} />;
    case "error":
      return <BiErrorCircle {...props} />;
    case "check-circle":
      return <BiCheckCircle {...props} />;
    case "external-link":
      return <FiExternalLink {...props} />;
    case "twitter":
      return <BsTwitterX {...props} />;
    case "twitter-old":
      return <AiOutlineTwitter {...props} />;
    case "linkedin":
      return <FaLinkedinIn {...props} />;
    case "fa-check":
      return <FaCheck {...props} />;
    case "fa-search":
      return <FaSearch {...props} />;
    case "up-chevron":
      return <FiChevronUp {...props} />;
    case "mail":
      return <FiMail {...props} />;
    case "fi-search":
      return <FiSearch {...props} />;
    case "md-arrow-down":
      return <MdKeyboardArrowDown {...props} />;
    case "md-arrow-up":
      return <MdKeyboardArrowUp {...props} />;
    case "md-arrow-left":
      return <MdOutlineKeyboardArrowLeft {...props} />;
    case "md-arrow-right":
      return <MdOutlineKeyboardArrowRight {...props} />;
    case "discourse":
      return <Discourse {...props} />;
    default:
      return null;
  }
};

export default Icon;